var map = {
	"./lang-en.css": "D8Rx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pf9D";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css ^\.\/lang\-.*\.css$
// module id = Pf9D
// module chunks = 55